import React from 'react';

export default function JobFormValidation({ errors = [] }) {
  if (errors.length === 0) return null;

  return (
    <div style={{
      padding: '12px 16px',
      background: '#fef2f2',
      border: '1px solid #fecaca',
      borderRadius: '8px',
      marginBottom: '16px'
    }}>
      <div style={{
        fontSize: '13px',
        fontWeight: '600',
        color: '#dc2626',
        marginBottom: '8px',
        display: 'flex',
        alignItems: 'center',
        gap: '6px'
      }}>
        <span>⚠️</span>
        <span>Please fix the following:</span>
      </div>
      
      <ul style={{
        margin: 0,
        paddingLeft: '20px',
        fontSize: '13px',
        color: '#991b1b'
      }}>
        {errors.map((error, index) => (
          <li key={index} style={{ marginBottom: '4px' }}>
            {error}
          </li>
        ))}
      </ul>
    </div>
  );
}

// Validation helper functions
export function validateJobForm(formData) {
  const errors = [];

  // Customer name required
  if (!formData.customerName || formData.customerName.trim() === '') {
    errors.push('Customer name is required');
  }

  // Location (name field) required
  if (!formData.name || formData.name.trim() === '') {
    errors.push('Job location/town is required');
  }

  // Contract number required
  if (!formData.contractNumber || formData.contractNumber.trim() === '') {
    errors.push('Contract number is required');
  }

  // Sold date required
  if (!formData.soldDate) {
    errors.push('Sold date is required');
  }

  // Phone number format (if provided)
  if (formData.phoneNumber && formData.phoneNumber.trim()) {
    const cleaned = formData.phoneNumber.replace(/\D/g, '');
    if (cleaned.length !== 10) {
      errors.push('Phone number must be 10 digits');
    }
  }

  // Email format (if provided)
  if (formData.customerEmail && formData.customerEmail.trim()) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.customerEmail)) {
      errors.push('Invalid email format');
    }
  }

  // Window/door counts must be positive
  if (formData.windowCount < 0) {
    errors.push('Window count cannot be negative');
  }
  if (formData.doorCount < 0) {
    errors.push('Door count cannot be negative');
  }

  // Duration must be at least 1
  if (formData.durationDays < 1) {
    errors.push('Duration must be at least 1 day');
  }

  return errors;
}